import { CircleX, Mail } from "lucide-react";
import { useMainStore } from "@/stores";
import { getTextInCapitalize } from "@/shared/utils/helperFunctions";
import { useNavigate } from "react-router-dom";

const AccessRequestRejected = () => {
  const { user } = useMainStore();
  const navigate = useNavigate();
  const rejectedBySalesworx =
    user?.rejectedBy === "salesworx" ||
    (user?.rejectedBy == null && user?.role === "org_admin");
  const orgName = user?.orgName || "your organization";

  const handleReturnToSignUp = () => {
    localStorage.removeItem("token");
    window.dispatchEvent(new Event("tokenUpdated"));
    navigate("/signup");
  };

  const statusTitle = rejectedBySalesworx
    ? "Access Rejected by SalesWorx"
    : "Access Rejected by Organization Admin";
  const statusMessage = rejectedBySalesworx
    ? "Your request for a SalesWorx workspace has been rejected by the SalesWorx team."
    : `Your request to join workspace "${getTextInCapitalize(orgName)}" has been rejected by your organization admin.`;

  const whatHappensNext = rejectedBySalesworx
    ? "If you believe this was a mistake, please contact the SalesWorx support team for assistance."
    : "If you believe this was a mistake, please contact your organization admin or reach out to SalesWorx support for help.";

  return (
    <div className="bg-[#F9FAFB] flex items-center justify-center h-[100dvh] w-full">
      <div className="border border-gray-200 rounded-2xl p-6 w-[47%] mx-auto bg-white flex flex-col gap-[22px] shadow-sm max-w-[540px]">
        {/* Red X icon */}
        <div className="flex flex-col items-center gap-3.5">
          <div className="w-16 h-16 rounded-full bg-error-50 flex items-center justify-center">
            <CircleX size={28} className="text-error-500" />
          </div>
          <h1 className="text-gray-800 text-[1.38rem] leading-8 font-medium">
            {statusTitle}
          </h1>
          <p className="text-gray-500 text-[0.9rem] leading-6 font-normal text-center">
            {statusMessage}
          </p>
        </div>

        {/* What happens next info box */}
        <div className="flex gap-2 p-4 bg-[#207C971A] rounded-[10px] border border-secondary">
          <Mail size={18} className="text-secondary flex-shrink-0" />
          <div className="flex flex-col">
            <h5 className="text-secondary text-[0.85rem] font-medium">
              What can you do?
            </h5>
            <p className="text-secondary text-[0.85rem] leading-5 font-normal">
              {whatHappensNext}
            </p>
          </div>
        </div>

        {/* Return to Sign Up */}
        <button
          onClick={handleReturnToSignUp}
          className="text-secondary font-normal text-[0.85rem] hover:underline transition-all duration-300 w-fit"
        >
          Return to Sign Up
        </button>

        <div className="h-[0.5px] bg-gray-200" />
        <p className="text-gray-500 text-[0.7rem] text-center leading-[18px] font-normal">
          Need help?{" "}
          <span className="text-secondary cursor-pointer hover:underline transition-all duration-300">
            Contact Support
          </span>
        </p>
      </div>
    </div>
  );
};

export default AccessRequestRejected;
